// extracted by mini-css-extract-plugin
module.exports = {"categoryTile":"CategorySlider_categoryTile__15yCm","categoryTileLabel":"CategorySlider_categoryTileLabel__9m83x"};